
// MainView Definition
const SPLASH = 0;
const LOGIN = 1;
const MAIN = 2;
const SETTINGS = 3;

const HOME = 0;
const RECOMMEND = 1;
const RESTAURANT = 2;
const EDITOR = 3;

const MONDAY = 'MON';
const TUESDAY = 'TUE';
const WEDNESDAY = 'WEN';
const THURSDAY = 'THU';
const FRIDAY = 'FRI';
const SATURDAY = 'SAT';
const SUNDAY = 'SUN';


const getDayFromCode = (dayCode) => {
    switch(dayCode){
        case MONDAY:
            return 'Lunes'
        case TUESDAY:
            return 'Martes'
        case WEDNESDAY:
            return 'Miercoles'
        case THURSDAY:
            return 'Jueves'
        case FRIDAY:
            return 'Viernes'
        case SATURDAY:
            return 'Sabado'
        case SUNDAY:
            return 'Domingo'
        default:
            return 'Sin Definir'
    }
}

const cookingTypes = [
    {
        name: 'Americana',
        code: 'American'
    },
    {
        name: 'Italiana',
        code: 'Italian'
    },
    {
        name: 'Guatemalteca',
        code: 'Guatemalan'
    },
    {
        name: 'Mexicana',
        code: 'Mexican'
    },
    {
        name: 'Salvadoreña',
        code: 'Salvador'
    },
    {
        name: 'Japonesa',
        code: 'Japanese'
    }
];

const dishStyles = [
    {
        label: 'Platos fuertes',
        value: 'MainCourse'
    },
    {
        label: 'Postres',
        value: 'Dessert'
    },
    {
        label: 'Cafe',
        value: 'Coffee'
    },
    {
        label: 'Panaderias',
        value: 'Bakery'
    },
    {
        label: 'Saludables',
        value: 'Healthy'
    }
];

export {
    SPLASH,
    LOGIN,
    MAIN,
    SETTINGS,
    HOME,
    RECOMMEND,
    RESTAURANT,
    EDITOR,
    cookingTypes,
    dishStyles,

    getDayFromCode
}